// A plan opened on existing data — a copied, imported or edited hike — has a
// route someone already put work into. The first few times a drag changes that
// route, a short notice says so and offers to undo it. It's there so a stray
// drag is never a mystery, not to narrate every edit. See RouteChangedToast.vue.

export const ROUTE_CHANGED_EVENT = 'planner-route-changed';
export const ROUTE_CHANGED_NOTICE_LIMIT = 3;

/** Tell the notice a drag just changed the route. Safe outside a browser. */
export function announceRouteChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ROUTE_CHANGED_EVENT));
}

/** Whether to show the notice, given whose route it is and how often it has shown this visit. */
export function shouldShowRouteChangedNotice(editingExistingData: boolean, shownSoFar: number): boolean {
  return editingExistingData && shownSoFar < ROUTE_CHANGED_NOTICE_LIMIT;
}
